import './style.scss'
export default (async function () {
  const { gsap } = await import('gsap');
  const { ScrollTrigger } = await import('gsap/dist/ScrollTrigger');

  const block = document.querySelector('.work-v6')

  if (!block) {
    return
  }

  gsap.registerPlugin(ScrollTrigger);
  const pics = block.querySelector('.work-v6__pic-list')

  gsap.to(pics, {
    scrollTrigger: {
      trigger: '.work-v6',
      start: '-400px bottom', // первое значение — от элемента, второе — от вьюпорта
      end: 'bottom -400px',
      scrub: true,
      toggleActions: 'restart pause reverse pause'
    },
    x: '25%',
    ease: 'none',
    duration: 4000
  });

  // Обновляет анимацию при изменении высоты страницы
  const resizeObserver = new ResizeObserver(() => {
    ScrollTrigger.refresh();
  });

  resizeObserver.observe(document.body);

  const description = block.querySelector('.work-v6__desc')
  const blockName = block.closest('[data-block-name]')?.dataset.blockName || 'Блок без названия'

  description.addEventListener('click', (evt) => {
    if (evt.target.closest('a')) {
      window.$analytics?.push('all-block-link-in-description-click', {
        blockName,
      })
    }
  })

  const returnLink = block.querySelector('.work-v6__link')

  returnLink?.addEventListener('click', () => {
    window.$analytics?.push('work-return-link-click')
  })
})();
